import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  exportTableColumnValidation,
  tableColumnValidation,
  TableSettingColumn,
} from 'types/tableSettingsTypes';

interface AdminIntegrationRequestState {
  excludedFilter: string[];
  filterData: Record<string, any>;
  reloadTableData: boolean;
  tableColumnValidation: tableColumnValidation;
  defaultColumnList: TableSettingColumn[];
  tableColumnList: TableSettingColumn[];
  exportTableColumnValidation: exportTableColumnValidation;
  exportTableColumnList: TableSettingColumn[];
}

const defaultColumnList = [
  {
    name: 'reported_by',
    label_key: 'reported_by',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 1,
  },
  {
    name: 'reason',
    label_key: 'reason',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 2,
  },
  {
    name: 'remarks',
    label_key: 'remarks',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 3,
  },
  {
    name: 'created_at',
    label_key: 'created_at',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 4,
  },
];

const defaultConfig = {
  allow_list: true,
  allow_filter: false,
  show_list_checkbox: true,
  show_filter_checkbox: false,
};

const fields = [
  { key: 'reported_by_name', label: 'reported_by' },
  { key: 'reported_by_email', label: 'reported_by_email' },
  { key: 'reason', label: 'reason' },
  { key: 'remarks', label: 'remarks' },
  { key: 'created_at', label: 'created_at' },
];

const exportColumnList = fields.map((field, index) => ({
  name: field.key,
  label_key: field.label,
  order: index + 1,
  ...defaultConfig,
}));

const initialState: AdminIntegrationRequestState = {
  excludedFilter: ['search'],
  filterData: {},
  reloadTableData: false,
  tableColumnValidation: {
    minListColumn: 2,
    maxListColumn: 4,
    minFilterColumn: 0,
    maxFilterColumn: 4,
  },
  defaultColumnList: defaultColumnList,
  tableColumnList: JSON.parse(JSON.stringify(defaultColumnList)),
  exportTableColumnValidation: {
    minListColumn: 2,
  },
  exportTableColumnList: exportColumnList,
};

const adminIntegrationRequestSlice = createSlice({
  name: 'adminIntegrationRequest',
  initialState,
  reducers: {
    setIntegrationRequestFilterData(state, action: PayloadAction<Record<string, any>>) {
      state.filterData = action.payload;
    },
    removeIntegrationRequestFilterKey(state, action: PayloadAction<string>) {
      delete state.filterData[action.payload];
    },
    resetIntegrationRequestFilterData(state) {
      state.filterData = {};
    },
    setIntegrationRequestReloadTableData(state, action: PayloadAction<boolean>) {
      state.reloadTableData = action.payload;
    },
    setIntegrationRequestTableColumnList(state, action: PayloadAction<TableSettingColumn[]>) {
      state.tableColumnList = action.payload;
    },
  },
});

export const {
  setIntegrationRequestFilterData,
  removeIntegrationRequestFilterKey,
  resetIntegrationRequestFilterData,
  setIntegrationRequestReloadTableData,
  setIntegrationRequestTableColumnList,
} = adminIntegrationRequestSlice.actions;

export default adminIntegrationRequestSlice.reducer;
